
















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _ from "lodash";
import { CuratedRtqPieChartDataItem, RiskToleranceType } from "@/shared/types";
import { GChart } from "vue-google-charts";
import { useThemeStore } from "@/shared/store/theme";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";

@Component({
  components: {
    GChart
  }
})
export default class CuratedRtqInstrumentsPieChart extends Vue {
  themeStore = useThemeStore();
  drivewealthStore = useDrivewealthStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();

  get chartDataItems (): CuratedRtqPieChartDataItem[] {
    return this.drivewealthStore.curatedRtqPieChartDataItems;
  }

  get getChartOptions () {
    return {
      colors: this.colorsToDisplay.map(x => x.chartColor),
      legend: {
        position: "right",
        alignment: "center"
      },
      chartArea: {
        top: 0,
        left: 0,
        width: "96%",
        height: "96%",
      },
      pieHole: 0.5,
      pieSliceText: "AllocationPercentage",
      enableInteractivity: true,
      tooltip: {
        isHtml: true,
      },
    };
  }

  get orderedColors () {
    return [
      {
        chartColor: this.themeStore.primaryColor,
        className: "primary"
      },
      {
        chartColor: this.themeStore.secondaryColor,
        className: "secondary"
      },
      {
        chartColor: this.themeStore.tertiaryColor,
        className: "tertiary"
      },
      {
        chartColor: this.themeStore.primaryColorShifts.lighter,
        className: "primary-lighter"
      },
      {
        chartColor: this.themeStore.secondaryColorShifts.lighter,
        className: "secondary-lighter"
      },
      {
        chartColor: this.themeStore.tertiaryColorShifts.lighter,
        className: "tertiary-lighter"
      },
      {
        chartColor: this.themeStore.primaryColorShifts.darker,
        className: "primary-darker"
      },
      {
        chartColor: this.themeStore.secondaryColorShifts.darker,
        className: "secondary-darker"
      },
      {
        chartColor: this.themeStore.tertiaryColorShifts.darker,
        className: "tertiary-darker"
      }
    ];
  }

  get colorsToDisplay () {
    const colors = this.chartDataItems.map((item, index) => ({
      ...item,
      ...this.orderedColors[index]
    }));

    return colors;
  }

  get chartData () {
    const items: any[] = [[
      "AssetCategoryName", "AllocationPercentage",
      { role: "tooltip", type: "string", p: { html: true } },
    ]];

    for (const color of this.colorsToDisplay) {
      const tooltipMarkup = this.tooltipFormatter(color.assetCategoryName, color.allocationPercentage);
      items.push([color.assetCategoryName, color.allocationPercentage, tooltipMarkup]);
    }

    return items;
  }

  tooltipFormatter (assetCategory: string, allocationPercentage: number): string {
    const markup = `<div margin-bottom: 3px;">
                          ${assetCategory}:
                        </div>
                        <div style="color: ${this.themeStore.tertiaryColor}; font-weight: bold;">
                          ${allocationPercentage}%
                        </div>`;

    return `<div style="padding: 2px 10px; min-width: 120px;">
              ${markup}
            </div>`;
  }
}
